'use client'

import { setRequestHeaders } from '../fetcher/client'
import { glovoRum } from '../o11y/client'
import { createDevice } from './device'
import { init } from './fingerprint'
import { initIncognia } from './providers/incognia'
import { getErrorMessage } from '@/tools/error-handling'

export { createDevice, updateDevice, getDeviceUrn } from './device'

export const initDeviceDetection = async () => {
  try {
    await Promise.all([init(), initIncognia()])
    const urn = await createDevice()

    if (urn) {
      setRequestHeaders('Glovo-Device-Urn', urn)
    }
    glovoRum.addAction('device_detection.init.success', { domain: 'device_detection' })
    // eslint-disable-next-line @glovo/custom-rules/always-forward-error
  } catch (e) {
    const errorMessage = getErrorMessage(e)
    if (errorMessage.includes('Client timeout')) {
      glovoRum.addAction('device_detection.init.timeout', { domain: 'device_detection' })
    } else {
      glovoRum.addError(e as Error, { domain: 'device_detection' })
    }
  }
}
